import AppError from './AppError';

export function NotFound() {
  return (
    <AppError
      title="Her var det ingenting..."
      description="Vi fant ikke siden du leter etter"
    />
  );
}
